import React from 'react'
import * as Sentry from '@sentry/react'
import { Button, Container, Card } from 'react-bootstrap'

const ErrorFallback = ({ error, resetError }) => {
  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Card
        className="p-4 shadow-sm text-center"
        style={{ maxWidth: '500px', borderRadius: '12px', border: 'none' }}
      >
        <div className="mb-3">
          <span style={{ fontSize: '48px' }}>⚠️</span>
        </div>
        <h4 className="fw-bold mb-2" style={{ color: '#212529' }}>
          Terjadi Kesalahan
        </h4>
        <p className="text-muted mb-4" style={{ fontSize: '14px' }}>
          Aplikasi mengalami kendala yang tidak terduga. Tim pengembang telah
          diberitahu melalui sistem monitoring.
        </p>
        <div className="d-flex justify-content-center gap-2">
          <Button
            variant="outline-secondary"
            onClick={() => window.location.reload()}
          >
            Muat Ulang Halaman
          </Button>
          <Button
            variant="warning"
            className="text-white"
            style={{
              backgroundColor: 'var(--primary-orange, #f7941d)',
              border: 'none'
            }}
            onClick={() => {
              if (resetError) resetError()
              window.location.href = '/'
            }}
          >
            Ke Beranda
          </Button>
        </div>
      </Card>
    </Container>
  )
}

const AppErrorBoundary = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default AppErrorBoundary
